/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
      "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };
  const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
  console.log("sessiondata", sessiondata)
  console.log("sessiondata", sessiondata)
  return (
    <>
      {/* begin::Menu Nav PT PRODI*/}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {sessiondata.i_idrole === 3 || sessiondata.i_idrole === 6 ? (
          <>
            <li className={`menu-item ${getMenuItemActive("/mpm", false)}`}>
              <NavLink className="menu-link" to="/mpm">
                <span className="svg-icon menu-icon">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Home.svg")} />
                </span>
                <span className="menu-text">Home</span>
              </NavLink>
            </li>
            <li className={`menu-item ${getMenuItemActive("/profile", false)}`}>
              <NavLink className="menu-link" to="/profile">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                  />
                </span>
                <span className="menu-text">Profil Perguruan Tinggi</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
            >
              <NavLink className="menu-link" to="/dashboard">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}
                  />
                </span>
                <span className="menu-text">Papan Info Perguruan Tinggi</span>
              </NavLink>
            </li>
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/react-bootstrap",
                true
              )}`}
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/react-bootstrap">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Home/Building.svg")}
                  />
                </span>
                <span className="menu-text">Penetapan</span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <ul className="menu-subnav">
                  <ul className="menu-subnav">
                    <li className="menu-item  menu-item-parent">
                      <span className="menu-link">
                        <span className="menu-text">Penetapan Perangkat SPMI</span>
                      </span>
                    </li>

                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/penetapan/pengaturan-komitmen-mutu"
                      )}`}
                    >
                      <NavLink
                        className="menu-link"
                        to="/penetapan/pengaturan-komitmen-mutu"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          Pengaturan Komitmen Mutu
                        </span>
                      </NavLink>
                    </li>
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/penetapan/pedoman-siklus"
                      )}`}
                    >
                      <NavLink
                        className="menu-link"
                        to="/penetapan/pedoman-siklus"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          <div>
                            Pedoman Siklus PPEPP
                            <OverlayTrigger
                              key="bottom"
                              placement="bottom"
                              overlay={
                                <Tooltip id={`tooltip-bottom`}>
                                  <div style={{ textAlign: 'left' }}>
                                    pedoman penerapan siklus penetapan, pelaksanaan, evaluasi, pengendalian, peningkatan standar pendidikan tinggi dalam SPM
                                  </div>
                                </Tooltip>
                              }
                            >
                              <span>
                                &nbsp;&nbsp;
                                <span style={{ fontSize: '15px' }} className="text-black fa fa-info-circle"></span>
                              </span>
                            </OverlayTrigger>
                          </div>
                        </span>
                      </NavLink>
                    </li>
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/penetapan/standar-yang-ditetapkan-institusi"
                      )}`}
                    >
                      <NavLink
                        className="menu-link"
                        to="/penetapan/standar-yang-ditetapkan-institusi"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Standar SPMI

                          <OverlayTrigger
                            key="bottom"
                            placement="bottom"
                            overlay={
                              <Tooltip id={`tooltip-bottom`}>
                                <div style={{ textAlign: 'left' }}>
                                  Standar dan/atau kriteria, norma, acuan mutu penyelenggaraan pendidikan dan pengelolaan perguruan tinggi
                                </div>
                              </Tooltip>
                            }
                          >
                            <span>
                              &nbsp;&nbsp;
                              <span style={{ fontSize: '15px' }} className="text-black fa fa-info-circle"></span>
                            </span>
                          </OverlayTrigger>
                        </span>
                      </NavLink>
                    </li>
                    {/*begin::2 Level*/}

                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/penetapan/mekanisme-pendokumentasian"
                      )}`}
                    >
                      <NavLink
                        className="menu-link"
                        to="/penetapan/mekanisme-pendokumentasian"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">Mekanisme Pendokumentasian

                          <OverlayTrigger
                            key="bottom"
                            placement="bottom"
                            overlay={
                              <Tooltip id={`tooltip-bottom`}>
                                <div style={{ textAlign: 'left' }}>
                                  Tata cara pendokumentasian implementasi SPMI
                                </div>
                              </Tooltip>
                            }
                          >
                            <span>
                              &nbsp;&nbsp;
                              <span style={{ fontSize: '15px' }} className="text-black fa fa-info-circle"></span>
                            </span>
                          </OverlayTrigger>
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                </ul>
              </div>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/pelaksanaan",
                false
              )}`}
            >
              <NavLink className="menu-link" to="/pelaksanaan">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Home/Book-open.svg")}
                  />
                </span>
                <span className="menu-text">Pelaksanaan</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive("/evaluasi", false)}`}
            >
              <NavLink className="menu-link" to="/evaluasi">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Clipboard-list.svg"
                    )}
                  />
                </span>
                <span className="menu-text">Evaluasi</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/pengendalian",
                false
              )}`}
            >
              <NavLink className="menu-link" to="/pengendalian">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Media/Repeat.svg")}
                  />
                </span>
                <span className="menu-text">Pengendalian</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/peningkatan",
                false
              )}`}
            >
              <NavLink className="menu-link" to="/peningkatan">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Home/Stairs.svg")}
                  />
                </span>
                <span className="menu-text">Peningkatan</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/dampak-tridharma",
                false
              )}`}
            >
              <NavLink className="menu-link" to="/dampak-tridharma">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Bookmark.svg")}
                  />
                </span>
                <span className="menu-text">Dampak Tridharma</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive("/informasi", false)}`}
            >
              <NavLink className="menu-link" to="/informasi">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Home/Library.svg")}
                  />
                </span>
                <span className="menu-text">Informasi</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/pengelola-pt",
                false
              )}`}
            >
              <NavLink className="menu-link" to="/pengelola-pt">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Loader.svg")}
                  />
                </span>
                <span className="menu-text">Pengelola PT</span>
              </NavLink>
            </li>
          </>
        ) : (
          <>
            <li
              className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
            >
              <NavLink className="menu-link" to="/dashboard">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Home/Book-open.svg")}
                  />
                </span>
                <span className="menu-text">Dashboard</span>
              </NavLink>
            </li>
            <li className="menu-section ">
              <h4 className="menu-text">Pencarian ...</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>

            <li
              className={`menu-item ${getMenuItemActive("/search-pt", false)}`}
            >
              <NavLink className="menu-link" to="/search-pt">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                  />
                </span>
                <span className="menu-text">SPMI Di Perguruan Tinggi</span>
              </NavLink>
            </li>

            {sessiondata.i_idrole === 10 || sessiondata.i_idrole === 2014 ? (
              <>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/penugasan-faswil",
                    false
                  )}`}
                >
                  <NavLink className="menu-link" to="/penugasan-faswil">
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                      />
                    </span>
                    <span className="menu-text">
                      Penugasan Fasilitator Wilayah
                    </span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/content-management-system",
                    false
                  )}`}
                >
                  <NavLink
                    className="menu-link"
                    to="/content-management-system"
                  >
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Home/Library.svg")}
                      />
                    </span>
                    <span className="menu-text">Content Management System</span>
                  </NavLink>
                </li>
              </>
            ) : (
              ""
            )}

            {sessiondata.i_idrole === 10 ? (
              <>
                <li
                  className={`menu-item menu-item-submenu ${getMenuItemActive(
                    "/react-bootstrap",
                    true
                  )}`}
                  data-menu-toggle="hover"
                >
                  <NavLink
                    className="menu-link menu-toggle"
                    to="/react-bootstrap"
                  >
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/Code/Option.svg")}
                      />
                    </span>
                    <span className="menu-text">Manajemen</span>
                    <i className="menu-arrow" />
                  </NavLink>
                  <div className="menu-submenu ">
                    <ul className="menu-subnav">
                      <ul className="menu-subnav">
                        <li
                          className={`menu-item menu-item-submenu ${getMenuItemActive(
                            "/react-bootstrap",
                            true
                          )}`}
                          data-menu-toggle="hover"
                        >
                          <NavLink
                            className="menu-link menu-toggle"
                            to="/react-bootstrap"
                          >
                            <span className="svg-icon menu-icon">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Design/Color-profile.svg"
                                )}
                              />
                            </span>
                            <span className="menu-text">Setting Akses</span>
                            <i className="menu-arrow" />
                          </NavLink>
                          <div className="menu-submenu ">
                            <ul className="menu-subnav">
                              <ul className="menu-subnav">
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/user",
                                    false
                                  )}`}
                                >
                                  <NavLink className="menu-link" to="/user">
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">User</span>
                                  </NavLink>
                                </li>
                                <li
                                  className={`menu-item ${getMenuItemActive(
                                    "/role",
                                    false
                                  )}`}
                                >
                                  <NavLink className="menu-link" to="/role">
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span />
                                    </i>
                                    <span className="menu-text">Role</span>
                                  </NavLink>
                                </li>
                              </ul>
                            </ul>
                          </div>
                        </li>
                        {/* <li
                          className={`menu-item ${getMenuItemActive(
                            "/content-management-system",
                            false
                          )}`}
                        >
                          <NavLink
                            className="menu-link"
                            to="/content-management-system"
                          >
                            <span className="svg-icon menu-icon">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Home/Library.svg"
                                )}
                              />
                            </span>
                            <span className="menu-text">
                              Content Management System
                            </span>
                          </NavLink>
                        </li> */}
                      </ul>
                    </ul>
                  </div>
                </li>
              </>
            ) : (
              ""
            )}

            {sessiondata.i_idrole !== 99 ? (
              <li
                className={`menu-item ${getMenuItemActive(
                  "/informasi",
                  false
                )}`}
              >
                <NavLink className="menu-link" to="/informasi">
                  <span className="svg-icon menu-icon">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Home/Library.svg"
                      )}
                    />
                  </span>
                  <span className="menu-text">Informasi</span>
                </NavLink>
              </li>
            ) : (
              ""
            )}

            {sessiondata.i_idrole === 10 || sessiondata.i_idrole === 99 ? (
              <>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/rekapitulasi",
                    false
                  )}`}
                >
                  <NavLink className="menu-link" to="/rekapitulasi">
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Shopping/Chart-bar1.svg"
                        )}
                      />
                    </span>
                    <span className="menu-text">Rekapitulasi</span>
                  </NavLink>
                </li>
              </>
            ) : (
              ""
            )}

            {sessiondata.i_idrole === 2 || sessiondata.i_idrole === 2014 ? (
              <>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/detail-lembaga",
                    false
                  )}`}
                >
                  <NavLink className="menu-link" to={`/detail-lembaga/${sessiondata.i_idunit}`}>
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Shopping/Chart-bar1.svg"
                        )}
                      />
                    </span>
                    <span className="menu-text">Rekapitulasi</span>
                  </NavLink>
                </li>
              </>
            ) : (
              ""
            )}
            {/* <li
                  className={`menu-item ${getMenuItemActive(
                    "/informasi",
                    false
                  )}`}
                >
                  <NavLink className="menu-link" to="/informasi">
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Shopping/loader.svg"
                        )}
                      />
                    </span>
                    <span className="menu-text">Informasi</span>
                  </NavLink>
                </li> */}

            {sessiondata.i_idrole === 10 ? (
              <>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/pengelola-pt",
                    false
                  )}`}
                >
                  <NavLink className="menu-link" to="/pengelola-pt">
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Shopping/Loader.svg"
                        )}
                      />
                    </span>
                    <span className="menu-text">Pengelola PT</span>
                  </NavLink>
                </li>
                {/* <li
                  className={`menu-item ${getMenuItemActive(
                    "/dampak-tridharma",
                    false
                  )}`}
                >
                  <NavLink className="menu-link" to="/dampak-tridharma">
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Bookmark.svg"
                        )}
                      />
                    </span>
                    <span className="menu-text">Dampak Tridharma</span>
                  </NavLink>
                </li> */}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/log-data",
                    false
                  )}`}
                >
                  <NavLink className="menu-link" to="/log-data">
                    <span className="svg-icon menu-icon">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Home/Commode2.svg"
                        )}
                      />
                    </span>
                    <span className="menu-text">Log Data</span>
                  </NavLink>
                </li>
              </>
            ) : (
              ""
            )}
          </>
        )}
      </ul>
    </>
  );
}
